<template>
  <div>
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="order"
        class="form"
        label-width="100px"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="数据同步" name="first">
          <el-row>
            <el-col :span="5">
              <el-form-item label="生产工单">
                <el-input v-model="order.productionNo" placeholder="请输入" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                  v-if="saveAuth"
                  style="margin-left: 20px;"
                  :loading="productLoading"
                  type="primary"
                  @click="productSubmit">
                确认
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="采购订单">
                <el-input v-model="order.purchaseNo" placeholder="请输入" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                  v-if="saveAuth"
                  style="margin-left: 20px;"
                  :loading="purchaseLoading"
                  type="primary"
                  @click="purchaseSubmit">
                确认
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="物料">
                <el-input v-model="order.materialNo" placeholder="请输入" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                  v-if="saveAuth"
                  style="margin-left: 20px;"
                  :loading="materialLoading"
                  type="primary"
                  @click="materialSubmit">
                确认
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="BOM">
                <el-input v-model="order.bomNo" placeholder="请输入" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                  v-if="saveAuth"
                  style="margin-left: 20px;"
                  :loading="bomLoading"
                  type="primary"
                  @click="bomSubmit">
                确认
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="客户">
                <el-input v-model="order.customerNo" placeholder="请输入" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                  v-if="saveAuth"
                  style="margin-left: 20px;"
                  :loading="customerLoading"
                  type="primary"
                  @click="customerSubmit">
                确认
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="发货通知单">
                <el-input v-model="order.deliveryNo" placeholder="请输入" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                  v-if="saveAuth"
                  style="margin-left: 20px;"
                  :loading="deliveryLoading"
                  type="primary"
                  @click="deliverySubmit">
                确认
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="销售出库单">
                <el-input v-model="order.mmDeliveryNo" placeholder="请输入" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                  v-if="saveAuth"
                  style="margin-left: 20px;"
                  :loading="mmDeliveryLoading"
                  type="primary"
                  @click="mmDeliverySubmit">
                确认
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="销售订单">
                <el-input v-model="order.salesOrderNo" placeholder="请输入" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                  v-if="saveAuth"
                  style="margin-left: 20px;"
                  :loading="salesLoading"
                  type="primary"
                  @click="salesOrderSubmit">
                确认
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="供应商">
<!--                <el-input v-model="order.salesOrderNo" placeholder="请输入" clearable/>-->
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button
                  v-if="saveAuth"
                  style="margin-left: 20px;"
                  :loading="supplierLoading"
                  type="primary"
                  @click="supplierSubmit">
                刷新
              </el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>

  export default {
    name: "ErpIndex",
    components: {},
    data() {
      return {
        saveAuth: this.$auth(431),
        dialogVisible: false,
        contentLoading: false,
        productLoading: false,
        materialLoading: false,
        bomLoading: false,
        customerLoading: false,
        purchaseLoading: false,
        deliveryLoading: false,
        mmDeliveryLoading: false,
        supplierLoading: false,
        activeName: "first",
        order: {
          productionNo: "",
          purchaseNo: "",
          materialNo: "",
          bomNo: "",
          customerNo: "",
          deliveryNo: "",
          salesOrderNo: "",
          mmDeliveryNo:"",
        },
      };
    },
    mounted() {
    },
    methods: {
      productSubmit() {
        if (!this.order.productionNo) {
          return;
        }
        this.productLoading = true;
        this.$http
          .get("basic", "erp/pProductionOrder/" + this.order.productionNo)
          .then((resp) => {
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("对接成功");
            }
            this.productLoading = false;
            this.dialogVisible = false;
            this.order.productionNo = "";
          })
          .catch(() => {
            this.productLoading = false;
          });
      },
      purchaseSubmit() {
        if (!this.order.purchaseNo) {
          return;
        }
        this.purchaseLoading = true;
        this.$http
          .get("basic", "erp/pPurchaseOrder/" + this.order.purchaseNo)
          .then((resp) => {
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("对接成功");
            }
            this.purchaseLoading = false;
            this.dialogVisible = false;
            this.order.purchaseNo = "";
          })
          .catch(() => {
            this.purchaseLoading = false;
          });
      },

      materialSubmit() {
        if (!this.order.materialNo) {
          return;
        }
        this.materialLoading = true;
        this.$http
          .post("basic", "erp/syncMaterial/0/" + this.order.materialNo)
          .then((resp) => {
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("对接成功");
            }
            this.materialLoading = false;
            this.dialogVisible = false;
            this.order.materialNo = "";
          })
          .catch(() => {
            this.materialLoading = false;
          });
      },

      bomSubmit() {
        if (!this.order.bomNo) {
          return;
        }
        this.bomLoading = true;
        this.$http
          .post("basic", "erp/getBom/" + this.order.bomNo)
          .then((resp) => {
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("对接成功");
            }
            this.bomLoading = false;
            this.dialogVisible = false;
            this.order.bomNo = "";
          })
          .catch(() => {
            this.bomLoading = false;
          });
      },

      customerSubmit() {
        if (!this.order.customerNo) {
          return;
        }
        this.customerLoading = true;
        this.$http
          .post("basic", "erp/syncCustomerByNo/" + this.order.customerNo)
          .then((resp) => {
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("对接成功");
            }
            this.customerLoading = false;
            this.dialogVisible = false;
            this.order.customerNo = "";
          })
          .catch(() => {
            this.customerLoading = false;
          });
      },
      deliverySubmit() {
        if (!this.order.deliveryNo) {
          return;
        }
        this.deliveryLoading = true;
        this.$http
          .get("basic", "erp/sDeliveryBill/" + this.order.deliveryNo)
          .then((resp) => {
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("对接成功");
            }
            this.deliveryLoading = false;
            this.dialogVisible = false;
            this.order.deliveryNo = "";
          })
          .catch(() => {
            this.deliveryLoading = false;
          });
      },
      mmDeliverySubmit() {
        if (!this.order.mmDeliveryNo) {
          return;
        }
        this.mmDeliveryLoading = true;
        this.$http
            .get("basic", "erp/mmDeliveryBill/" + this.order.mmDeliveryNo)
            .then((resp) => {
              if (resp.success) {
                this.$emit("save-success");
                this.$message.success("对接成功");
              }
              this.mmDeliveryLoading = false;
              this.dialogVisible = false;
              this.order.mmDeliveryNo = "";
            })
            .catch(() => {
              this.mmDeliveryLoading = false;
            });
      },
      salesOrderSubmit() {
        if (!this.order.salesOrderNo) {
          return;
        }
        this.salesLoading = true;
        this.$http
          .get("basic", "erp/sOrder/" + this.order.salesOrderNo)
          .then((resp) => {
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("对接成功");
            }
            this.salesLoading = false;
            this.dialogVisible = false;
            this.order.salesOrderNo = "";
          })
          .catch(() => {
            this.salesLoading = false;
          });
      },
      supplierSubmit() {
        this.supplierLoading = true;
        this.$http
            .post("basic", "erp/syncSupplier")
            .then((resp) => {
              if (resp.success) {
                this.$emit("save-success");
                this.$message.success("对接成功");
              }
              this.supplierLoading = false;
              this.dialogVisible = false;
            })
            .catch(() => {
              this.supplierLoading = false;
            });
      },

    },
  };
</script>

<style scoped></style>
